export function normalizeOdometerValue(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = parseInt(String(value).replace(/[^0-9-]/g, ''), 10);
  return Number.isFinite(parsed) ? parsed : null;
}

export function hasOdometerChanged(currentValue, nextValue) {
  return normalizeOdometerValue(currentValue) !== normalizeOdometerValue(nextValue);
}

let odometerConfirmHandler = null;

export function registerOdometerConfirm(handler) {
  odometerConfirmHandler = typeof handler === 'function' ? handler : null;
}

export async function confirmOdometerUpdate({
  currentValue,
  nextValue,
  context = 'update this odometer reading',
}) {
  const current = normalizeOdometerValue(currentValue);
  const next = normalizeOdometerValue(nextValue);

  if (next === null || current === next) return true;

  const currentLabel = current === null ? 'empty' : `${current.toLocaleString()} km`;
  const nextLabel = `${next.toLocaleString()} km`;

  if (odometerConfirmHandler) {
    return odometerConfirmHandler({
      currentValue: current,
      nextValue: next,
      currentLabel,
      nextLabel,
      context,
    });
  }

  return window.confirm(`Confirm odometer update?\n\nCurrent: ${currentLabel}\nNew: ${nextLabel}\n\nThis will ${context}.`);
}
